export default __webpack_public_path__ + "pgnv-assets/23c2dfd1e072d515b4b6d6ec35730b17.png";